import { render, staticRenderFns } from "./NodeButton.vue?vue&type=template&id=40b0f432"
import script from "./NodeButton.vue?vue&type=script&lang=js"
export * from "./NodeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports